import { Component, ElementRef } from '@angular/core';
import { LabelService } from './shared/services/label.service';
import { DealsData } from './shared/models/dealsdata.model';
import { Deal } from './shared/models/deal.model';
import { assertIsDefined } from './shared/utils/assert.utils';
import { WalksData } from './shared/models/walksdata.model';
import { Walk } from './shared/models/walk.model';
import { NgIf } from '@angular/common';
import { WalksComponent } from './components/walks/walks.component';
import { DealsComponent } from './components/deals/deals.component';

@Component({
  selector: 'app-dagjeuit',
  templateUrl: 'app.component.html',
  imports: [NgIf, WalksComponent, DealsComponent],
})
export class AppComponent {
  walksData?: WalksData;
  dealsData?: DealsData;

  /**
   *
   * @param elementRef
   * @param labelService
   */
  constructor(
    private elementRef: ElementRef,
    private labelService: LabelService,
  ) {
    const appData = elementRef.nativeElement.getAttribute('appData');
    if (appData) {
      const parsedData = JSON.parse(appData);
      const category = elementRef.nativeElement.getAttribute('category');
      switch (category) {
        case 'deals':
          this.dealsData = Object.assign(new DealsData(), parsedData);
          assertIsDefined(this.dealsData);
          this.dealsData.results = this.dealsData.results?.map((result) =>
            Object.assign(new Deal(), result),
          );
          break;
        case 'walks':
          this.walksData = Object.assign(new WalksData(), parsedData);
          assertIsDefined(this.walksData);
          this.walksData.results = this.walksData.results?.map((result) =>
            Object.assign(new Walk(), result),
          );
          break;
        default:
          throw new Error(`Unsupported or missing category: ${category}`);
      }
    }

    const labels: string = elementRef.nativeElement.getAttribute('labels');
    this.labelService.labels = labels ? JSON.parse(labels) : {};
  }
}
